import type { QueryClient } from '@tanstack/react-query';

/** 홈페이지 미리보기가 쓰는 공개 조회 쿼리의 이름(`coreQueryKey`의 domain 자리). */
export const HOMEPAGE_PREVIEW_QUERY_PREFIX = 'public-midterm-';

/**
 * 사진·문구·FAQ를 저장한 뒤 호출한다. 미리보기는 짧게 캐시하므로, 저장 직후에는 다시 열 때
 * 새로 읽도록 표시만 해 둔다(지금 열려 있지 않으면 요청은 나가지 않는다).
 */
export function invalidateHomepagePreview(client: QueryClient) {
  return client.invalidateQueries({
    predicate: (query) => {
      const domain = query.queryKey[3];
      return typeof domain === 'string' && domain.startsWith(HOMEPAGE_PREVIEW_QUERY_PREFIX);
    },
  });
}
